import React  from 'react'
// import noteContext from '../context/note/noteContext'
import Notes from './Notes';

const Home = () => {
  // const s=useContext(noteContext);
  return (
    <div>
      <Notes/>
    </div>
  )
}

export default Home
